import { render, staticRenderFns } from "./PProjectList.vue?vue&type=template&id=3337833a&"
import script from "./PProjectList.vue?vue&type=script&lang=ts&"
export * from "./PProjectList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports